import { render, staticRenderFns } from "./ExternalGameRedirect.vue?vue&type=template&id=ef80edf4"
import script from "./ExternalGameRedirect.vue?vue&type=script&lang=js"
export * from "./ExternalGameRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports